<template>
  <div v-if="filteredResults.length" class="container">
    <div class="card-group">

      <!-- AppDisplayPost Component -->
      <app-display-post
        v-for="movie in filteredResults"
        :key="movie.id"
        :search-term="searchTerm"
        :movie="movie"
        role="article" >
        <!-- AppDisplayPost is called for each post in the filteredResults -->
      </app-display-post>

    </div><!-- .card-group -->
  </div><!-- .container -->
  <div v-else>
    <p class="text-center"> Loading ⏳ </p>
  </div>
</template>

<script>
import AppDisplayPost from './AppDisplayPost.vue';

export default {
	components: {
		'app-display-post': AppDisplayPost
	},
	data() {
		return {
			searchTerm: '',
			filteredResults: [],
			emitHighlighTag: false
		};
	},
	mounted() {
		this.emitter.on('filteredPosts', data => {
			this.filteredResults = data;
			if (this.emitHighlighTag) {
				const queryParamsTag = this.$route.query.tag;
				if (!queryParamsTag) return
				let tag = queryParamsTag.replace('_', ' ')
				this.emitter.emit('highlightTag', tag) 
				this.emitHighlighTag = false
			}
		});
		this.emitter.on('searchTermChanged', data => {
			this.searchTerm = data;
		});

		const queryParamsTag = this.$route.query.tag;
		if (queryParamsTag) {
			let tag = queryParamsTag.replace('_', ' ')
			this.emitter.emit('filterByQueryParamTag', tag) 
			this.emitHighlighTag = true
		} else {
			this.emitter.emit('getFilteredPosts')
		}
	}
};
</script>

<style scoped>

.card-group {
	gap: 20px;
	justify-content: flex-start;
}

.container {
	margin-inline: 0;
}

</style>
